import { sofiaProMedium, sofiaProSemiBold } from 'src/components/theme/fonts'

export const stat1: React.CSSProperties = {
  fontFamily: sofiaProSemiBold.fontFamily,
  fontSize: 40,
  lineHeight: '40px',
  letterSpacing: 0,
  fontWeight: 700,
}

export const header1: React.CSSProperties = {
  fontFamily: sofiaProSemiBold.fontFamily,
  fontSize: 30,
  lineHeight: '28px',
  letterSpacing: 0,
  fontWeight: 700,
}

export const header1m: React.CSSProperties = {
  fontFamily: sofiaProMedium.fontFamily,
  fontSize: 30,
  lineHeight: '28px',
  letterSpacing: 0,
  fontWeight: 500,
}

export const header2: React.CSSProperties = {
  fontFamily: sofiaProSemiBold.fontFamily,
  fontSize: 22,
  lineHeight: '20px',
  letterSpacing: 0,
  fontWeight: 700,
}

export const header3: React.CSSProperties = {
  fontFamily: sofiaProSemiBold.fontFamily,
  fontSize: 18,
  lineHeight: '19px',
  letterSpacing: 0,
  fontWeight: 700,
}

export const header3s: React.CSSProperties = {
  fontFamily: sofiaProMedium.fontFamily,
  fontSize: 18,
  lineHeight: '19px',
  letterSpacing: 0,
  fontWeight: 400,
}

export const title1: React.CSSProperties = {
  fontFamily: sofiaProSemiBold.fontFamily,
  fontSize: 17,
  lineHeight: '19px',
  letterSpacing: 0,
  fontWeight: 700,
}

export const title2: React.CSSProperties = {
  fontFamily: sofiaProSemiBold.fontFamily,
  fontSize: 16,
  lineHeight: '21px',
  letterSpacing: 0,
  fontWeight: 700,
}

export const title2l: React.CSSProperties = {
  fontFamily: sofiaProMedium.fontFamily,
  fontSize: 16,
  lineHeight: '21px',
  letterSpacing: 0,
  fontWeight: 400,
}

export const title2m: React.CSSProperties = {
  fontFamily: sofiaProMedium.fontFamily,
  fontSize: 14,
  lineHeight: '16px',
  letterSpacing: 0,
  fontWeight: 400,
}

export const textlg: React.CSSProperties = {
  fontFamily: sofiaProSemiBold.fontFamily,
  fontSize: 15,
  lineHeight: '17px',
  letterSpacing: 0,
  fontWeight: 700,
}

export const textlgm: React.CSSProperties = {
  fontFamily: sofiaProMedium.fontFamily,
  fontSize: 15,
  lineHeight: '17px',
  letterSpacing: 0,
  fontWeight: 400,
}

export const textmd: React.CSSProperties = {
  fontFamily: sofiaProSemiBold.fontFamily,
  fontSize: 14,
  lineHeight: '17px',
  letterSpacing: 0,
  fontWeight: 700,
}

export const textmdm: React.CSSProperties = {
  fontFamily: sofiaProMedium.fontFamily,
  fontSize: 14,
  lineHeight: '17.5px',
  letterSpacing: 0,
  fontWeight: 400,
}

export const text1: React.CSSProperties = {
  fontFamily: sofiaProSemiBold.fontFamily,
  fontSize: 12,
  lineHeight: '16px',
  letterSpacing: 0,
  fontWeight: 700,
}

export const text1m: React.CSSProperties = {
  fontFamily: sofiaProMedium.fontFamily,
  fontSize: 12,
  lineHeight: '16px',
  letterSpacing: 0,
  fontWeight: 400,
}

export const text2: React.CSSProperties = {
  fontFamily: sofiaProSemiBold.fontFamily,
  fontSize: 11,
  lineHeight: '16px',
  letterSpacing: 0,
  fontWeight: 700,
}

export const text2m: React.CSSProperties = {
  fontFamily: sofiaProMedium.fontFamily,
  fontSize: 11,
  lineHeight: '16px',
  letterSpacing: 0,
  fontWeight: 400,
}

export const text3: React.CSSProperties = {
  fontFamily: sofiaProSemiBold.fontFamily,
  fontSize: 10,
  lineHeight: '16px',
  letterSpacing: 0,
  fontWeight: 700,
}

export const text3m: React.CSSProperties = {
  fontFamily: sofiaProMedium.fontFamily,
  fontSize: 10,
  lineHeight: '16px',
  letterSpacing: 0,
  fontWeight: 400,
}

export const caption1: React.CSSProperties = {
  fontFamily: sofiaProSemiBold.fontFamily,
  fontSize: 9,
  lineHeight: '11px',
  letterSpacing: 0,
  fontWeight: 700,
}

export const caption1m: React.CSSProperties = {
  fontFamily: sofiaProMedium.fontFamily,
  fontSize: 9,
  lineHeight: '11px',
  letterSpacing: 0,
  fontWeight: 400,
}

export const caption1sm: React.CSSProperties = {
  fontFamily: sofiaProMedium.fontFamily,
  fontSize: 8,
  lineHeight: '11px',
  letterSpacing: 0,
  fontWeight: 400,
}
